import React, { useEffect } from "react";
import { Box, Container, Typography, Grid, Button, Link } from "@mui/material";
import { motion } from "framer-motion";
// import heroBg from "../assets/nextix/contact-us-banner.jpg";

const ContactUsScreen = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const LocationBlock = ({ title, address, phone, mobile }) => (
        <Box sx={{ mb: 6, textAlign: 'start' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: "#375ca8" }}>
                {title}
            </Typography>
            <Typography variant="body1" sx={{ color: "#666", lineHeight: 1.8, mb: 1 }}>
                {address.map((line, index) => (
                    <React.Fragment key={index}>
                        {line}
                        <br />
                    </React.Fragment>
                ))}
            </Typography>
            {phone && (
                <Typography variant="body1" sx={{ color: "#666", lineHeight: 1.8 }}>
                    <strong>Telephone:</strong> {phone}
                </Typography>
            )}
            {mobile && (
                <Typography variant="body1" sx={{ color: "#666", lineHeight: 1.8 }}>
                    <strong>Mobile:</strong> {mobile}
                </Typography>
            )}
        </Box>
    );

    return (
        <Box sx={{ backgroundColor: "#fff", pt: 12 }}>

            {/* MAIN CONTENT */}
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <Grid container spacing={6}>
                    {/* Left Column - Locations */}
                    <Grid item xs={12} md={6} sx={{ textAlign: 'start' }}>
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            <Typography variant="h4" sx={{ fontWeight: 700, mb: 4, color: "#375ca8" }}>
                                Our Office Locations
                            </Typography>

                            <LocationBlock
                                title="Manila, Philippines Office:"
                                address={[
                                    "3rd Flr Montivar Bldg., 34 Jupiter St.,",
                                    "Brgy., Bel-air, Makati City 1200"
                                ]}
                                phone="+63 (2) 8828-1011"
                                mobile="0915 926 2398"
                            />

                            <LocationBlock
                                title="Cebu, Philippines Office:"
                                address={[
                                    "5 Ma. Cristina St.",
                                    "Brgy. Capitol Site",
                                    "Cebu City 6000 Philippines"
                                ]}
                                phone="+63 (32) 384-9309"
                            />
                        </motion.div>
                    </Grid>

                    {/* Right Column - Form & Email */}
                    <Grid item xs={12} md={6}>
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                        >
                            <Box sx={{ mt: 6, textAlign: 'start' }}>
                                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: "#375ca8" }}>
                                    Email Us:
                                </Typography>
                                <Typography variant="body1" sx={{ color: "#666", mb: 1 }}>
                                    <strong>Inquiry:</strong>{" "}
                                    <Link href="mailto:info@nextix.co" sx={{ color: "#375ca8", textDecoration: "none" }}>
                                        info@nextix.co
                                    </Link>
                                </Typography>
                                <Typography variant="body1" sx={{ color: "#666", mb: 1 }}>
                                    <strong>Support:</strong>{" "}
                                    <Link href="mailto:support@nextix.co" sx={{ color: "#375ca8", textDecoration: "none" }}>
                                        support@nextix.co
                                    </Link>
                                </Typography>
                                <Typography variant="body1" sx={{ color: "#666" }}>
                                    <strong>Privacy:</strong>{" "}
                                    <Link href="mailto:dpo@nextix.co" sx={{ color: "#375ca8", textDecoration: "none" }}>
                                        dpo@nextix.co
                                    </Link>
                                </Typography>
                            </Box>
                        </motion.div>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default ContactUsScreen;